module.exports = __webpack_public_path__ + "static/Ansible_Balloon-51549b7aa89647190691d543aea99fd2.png";